import { render, staticRenderFns } from "./RunCard.vue?vue&type=template&id=27c7f26b&"
import script from "./RunCard.vue?vue&type=script&lang=ts&"
export * from "./RunCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports